import React from "react";
import { Phone, MapPin, User } from "lucide-react";
import { contactInfo } from "../utils/mockData";

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleWhatsApp = () => {
    window.open(
      `https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, "")}`,
      "_blank",
    );
  };

  return (
    <footer className="bg-gray-50 dark:bg-[#0F0F0F] border-t border-gray-200 dark:border-gray-800 pt-16 pb-8">
      <div className="container px-4 mx-auto sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 mb-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold text-[#D32F2F] mb-4">
              Dreams Marketing
            </h3>
            <p className="mb-6 leading-relaxed text-gray-600 dark:text-gray-400">
              Partner pertumbuhan digital Anda untuk Social Media Management,
              Creative Design, dan Digital Training.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="mb-4 font-semibold text-gray-900 dark:text-white">
              Layanan
            </h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection("layanan")}
                  className="text-gray-600 dark:text-gray-400 hover:text-[#D32F2F] dark:hover:text-[#D32F2F] transition-colors"
                >
                  Social Media Management
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("layanan")}
                  className="text-gray-600 dark:text-gray-400 hover:text-[#D32F2F] dark:hover:text-[#D32F2F] transition-colors"
                >
                  Graphic Design & Video Editing
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("layanan")}
                  className="text-gray-600 dark:text-gray-400 hover:text-[#D32F2F] dark:hover:text-[#D32F2F] transition-colors"
                >
                  Digital Marketing Training
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("diantosan")}
                  className="text-gray-600 dark:text-gray-400 hover:text-[#D32F2F] dark:hover:text-[#D32F2F] transition-colors"
                >
                  Program Diantosan
                </button>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="mb-4 font-semibold text-gray-900 dark:text-white">
              Tautan Cepat
            </h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection("tentang")}
                  className="text-gray-600 dark:text-gray-400 hover:text-[#D32F2F] dark:hover:text-[#D32F2F] transition-colors"
                >
                  Tentang Kami
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("tim")}
                  className="text-gray-600 dark:text-gray-400 hover:text-[#D32F2F] dark:hover:text-[#D32F2F] transition-colors"
                >
                  Tim Kami
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("trial-demo")}
                  className="text-gray-600 dark:text-gray-400 hover:text-[#D32F2F] dark:hover:text-[#D32F2F] transition-colors"
                >
                  Trial Demo
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("kontak")}
                  className="text-gray-600 dark:text-gray-400 hover:text-[#D32F2F] dark:hover:text-[#D32F2F] transition-colors"
                >
                  Hubungi Kami
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="mb-4 font-semibold text-gray-900 dark:text-white">
              Kontak
            </h4>
            <ul className="space-y-3">
              {/* Phone / WhatsApp */}
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-[#D32F2F] flex-shrink-0 mt-0.5" />
                <a
                  href={`https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, "")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 dark:text-gray-400 hover:text-[#D32F2F] transition-colors"
                >
                  {contactInfo.phone}
                </a>
              </li>

              {/* Name */}
              <li className="flex items-start space-x-3">
                <User className="w-5 h-5 text-[#D32F2F] flex-shrink-0 mt-0.5" />
                <span className="text-gray-600 dark:text-gray-400">
                  {contactInfo.name}
                </span>
              </li>

              {/* Address */}
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#D32F2F] flex-shrink-0 mt-0.5" />
                <span className="leading-relaxed text-gray-600 dark:text-gray-400">
                  {contactInfo.address}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col items-center justify-between pt-8 space-y-4 border-t border-gray-200 dark:border-gray-800 md:flex-row md:space-y-0">
          <p className="text-sm text-center text-gray-600 dark:text-gray-400 md:text-left">
            © {new Date().getFullYear()} Dreams Marketing. All rights reserved.
          </p>
          <button
            onClick={handleWhatsApp}
            className="text-sm text-gray-600 dark:text-gray-400 hover:text-[#D32F2F] dark:hover:text-[#D32F2F] transition-colors"
          >
            Hubungi via WhatsApp
          </button>
        </div>
      </div>
    </footer>
  );
};
